import { propIn } from '../../../common/utils/immutableHelper';
import { ImElementLocalData } from './elementLocalDataTypes';

// Local error can be a string or a structured error object; treat as unknown.
export const getLocalError: (data: ImElementLocalData) => unknown = propIn(['error']);
export const getLocalShouldLoadPreview: (data: ImElementLocalData) => string | null = propIn(['shouldLoadPreview']);
export const getLocalUrl: (data: ImElementLocalData) => string = propIn(['url']);

export const getLocalHidden: (data: ImElementLocalData) => boolean = propIn(['hidden']);
